/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Ticketing options
 * @export
 * @interface EventAttributesTicketing
 */
export interface EventAttributesTicketing {
    /**
     * Online ticketing status
     * @type {boolean}
     * @memberof EventAttributesTicketing
     */
    active?: boolean;
    /**
     * Overall availability status
     * @type {boolean}
     * @memberof EventAttributesTicketing
     */
    ticketsAvailable?: boolean;
    /**
     * List of ticket categories
     * @type {Array<object>}
     * @memberof EventAttributesTicketing
     */
    ticketCategories?: Array<object>;
    /**
     * Online ticketing closed after date/time
     * @type {Date}
     * @memberof EventAttributesTicketing
     */
    closingTime?: Date;
}

export function EventAttributesTicketingFromJSON(json: any): EventAttributesTicketing {
    return EventAttributesTicketingFromJSONTyped(json, false);
}

export function EventAttributesTicketingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAttributesTicketing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'ticketsAvailable': !exists(json, 'ticketsAvailable') ? undefined : json['ticketsAvailable'],
        'ticketCategories': !exists(json, 'ticketCategories') ? undefined : json['ticketCategories'],
        'closingTime': !exists(json, 'closingTime') ? undefined : (new Date(json['closingTime'])),
    };
}

export function EventAttributesTicketingToJSON(value?: EventAttributesTicketing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'ticketsAvailable': value.ticketsAvailable,
        'ticketCategories': value.ticketCategories,
        'closingTime': value.closingTime === undefined ? undefined : (value.closingTime.toISOString()),
    };
}

